import clients from '@/store/tenancy/clients';
import sites from '@/store/tenancy/sites';
import { Dispatch } from 'vuex';

export default {
	namespaced: true,
	modules: {
		clients,
		sites,
	},
	actions: {
		async fetchAllTenancy({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.allSettled([dispatch('clients/fetchClients'), dispatch('sites/fetchSites')]);
		},

		cleanAllTenancy({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('clients/cleanAllClient');
			dispatch('sites/cleanAllSite');
		},
	},
};
